import { render, staticRenderFns } from "./size-expand.vue?vue&type=template&id=12c16de3&scoped=true&"
import script from "./size-expand.vue?vue&type=script&lang=js&"
export * from "./size-expand.vue?vue&type=script&lang=js&"
import style1 from "./size-expand.vue?vue&type=style&index=1&id=12c16de3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c16de3",
  null
  
)

export default component.exports